import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import ExpandableSection from "../../expandablesection";
import DoorSearch from "./DoorSearch"; // Import DoorSearch component
import DoorCollection from "./DoorCollection";
import GrainFilter from "./GrainFilter";
import DoorItems from "./DoorItems";
import Test from "./test";

const PanelDoorpanel = forwardRef(({ onChange, doorSizeValueTriggered, 
                                               doorHeightValueTriggered, 
                                               passSelectedDoor }, ref) => {
  const [doorSearchValue, setDoorSearchValue] = useState(""); // Updated state for DoorSearch
  const [doorCollectionValue, setDoorCollectionValue] = useState("");
  const [grainFilterValue, setGrainFilterValue] = useState("");
  const [doorItemsValue, setDoorItemsValue] = useState([]);
  const [selectedPanelValue, setSelectedPanelValue] = useState();
  const [testValue, setTestValue] = useState();



  // Method to retrieve all active controls and their values
  const getActiveControlsWithValues = () => {
    const values = {};

    controlMap
      .filter((control) => control.status === "active") // Only active controls
      .forEach((control) => {
        if (["Test", "DoorItems"].includes(control.id)) {
              // Use state value for Test component
              if (control.id === "Test"){
                 values[control.id] = testValue ? testValue.value : null;
              }
              if (control.id === "DoorItems"){
                values[control.id] = selectedPanelValue ? selectedPanelValue.value : null;
             }
        } else {  
              const element = document.getElementById(control.id); // Query by control ID
              if (element) {
                values[control.id] = element.value; // Retrieve the current value
              } else {
                values[control.id] = null; // Handle missing elements
              }
        }
      });

    return values;
  };

  // Expose the `getActiveControlsWithValues` method to the parent via ref
  useImperativeHandle(ref, () => ({
    getActiveControlsWithValues,
  }));

  // Notify parent component whenever values change
  useEffect(() => {
    onChange({
      doorSearch: doorSearchValue, // Updated the property name for DoorSearch
      doorCollection: doorCollectionValue,
      grainFilter: grainFilterValue,
      doorItems: doorItemsValue,
      selectedPanel: selectedPanelValue,
      test: testValue,
    });
  }, [doorSearchValue, doorCollectionValue, grainFilterValue, doorItemsValue, selectedPanelValue, testValue, onChange]);

  // Control map specific to DoorPanel
  const controlMap = [
    {
      id: "DoorSearch",
      component: (
        <DoorSearch
          id="DoorSearch"
          placeholder="Search..." // Placeholder for the search input
          onChange={(newValue) => {
            setDoorSearchValue(newValue); // Update state for DoorSearch
          }}
        />
      ),
      position: [1, 1],
      status: "active",
      expandableSectionId: "DoorPanel",
    },
    {
      id: "DoorCollection",
      component: (
        <DoorCollection
          id="DoorCollection"
          onChange={(newValue) => {
            setDoorCollectionValue(newValue); 
          }}
        />
      ),
      position: [2, 1],
      status: "active",
      expandableSectionId: "DoorPanel",
      },
      {
        id: "GrainFilter",
        component: (
          <GrainFilter
            id="GrainFilter"
            onChange={(newValue) => {
              setGrainFilterValue(newValue); 
            }}
          />
        ),
        position: [2, 2],
        status: "active",
        expandableSectionId: "DoorPanel",
        },
      {
        id: "DoorItems",
        component: (
          <DoorItems
            id="DoorItems"
            value = {selectedPanelValue}
            onChange={(newValue) => {
              setSelectedPanelValue(newValue); 
              //alert(JSON.stringify(newValue, null, 2));
            }}
            selectedCollection={doorCollectionValue} // Pass DoorCollection value
            selectedGrainFilter={grainFilterValue} // Pass DoorCollection value
            doorSizeValueToFunc={doorSizeValueTriggered} // Pass the actual prop
            doorHeightValueToFunc={doorHeightValueTriggered} // Pass the actual prop
            passSelectedDoor={passSelectedDoor} //pass selected door
            searchByName={doorSearchValue}
          />
        ),
        position: [3, 1],
        status: "active",
        expandableSectionId: "DoorPanel",
      },
      {
        id: "Test",
        component: (
          <Test
            id="Test"
            value={testValue} // Pass the current value back to Test (optional)
            onChange={(newValue) => {
              setTestValue(newValue); 
              console.log("Selected Item:", newValue); // For debugging
              //alert(newValue.value)
              alert(JSON.stringify(newValue, null, 2));

              //setSelectedTestItem(newValue);  // Update the selectedTestItem in parent
            }}
          />
        ),
        position: [4, 1],
        status: "inactive",
        expandableSectionId: "DoorPanel",
      },
  ];

  return (
    <ExpandableSection
      title={`Door Panel${selectedPanelValue ? ` (${selectedPanelValue.value})` : ""}`} // Dynamically add selected panel name
      panelLocation="115"
      controlMap={controlMap.filter((control) => control.expandableSectionId === "DoorPanel")}
    />
  );
});

export default PanelDoorpanel;
